import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'

import Drawing from '../components/Drawing'

const _ = require('lodash')

const AUTO_SQUARE_SELECT = 'automatic'

const DrawingContainer = ({
  drawing,
  drawingSquares,
  isNextDrawing,
  drawingId,
  drawingIndex,
  firebase,
  userId,
  history,
  squareSelectionMode,
}) => {
  const [alertMessage, setAlert] = useState()
  const [autoSelectionInitiated, setAutoSelectedInitiated] = useState()

  const redirectToDraw = (userDrawingId) => {
    const urlPath = `/drawings/${drawingId}/${drawingIndex}/draw/${userDrawingId}`
    history.push(urlPath)
  }

  const selectSquare = async (squareNumber) => {
    const squareRef = firebase.ref(`/drawings/${drawingId}/squares`)
    const squareIndex = squareNumber - 1
    const lotteryNumber = Math.floor(Math.random() * 1000000)

    await squareRef.transaction(
      (currentData) => {
        if (currentData[squareIndex] === false) {
          return { ...currentData, [squareIndex]: lotteryNumber }
        } else {
          return
        }
      },
      (error, commited, snapshot) => {
        if (snapshot.val()[squareIndex] === lotteryNumber) {
          const userDrawing = `${userId}${drawingId}_${drawingIndex}_${squareNumber}`
          firebase
            .ref(`drawingSquares/${userDrawing}`)
            .set({
              user_drawing: userDrawing,
              drawing: `${drawingId}_${drawingIndex}`,
              drawing_squareNumber: `${drawingId}_${drawingIndex}_${squareNumber}`,
              user: userId,
              squareNumber,
            })
            .then(() => {
              const userDrw = `${userId}_${drawingId}_${drawingIndex}`
              const data = {
                userDrawingSquare: userDrw,
                canvasSnapshot: { version: '2.4.1', objects: [] },
                user: userId,
                drawing: drawingId,
                userDrawing: userDrw,
                drawingSquare: squareNumber,
                startTimestamp: new Date().valueOf(),
              }
              firebase
                .ref(`canvasSnapshots/${userDrawing}`)
                .update(data)
                .then(() => {
                  redirectToDraw(userDrawing)
                })
            })
        } else {
          setAlert('This square is already taken, please choose another one')
        }
      },
    )
  }

  const autoSelectSquare = () => {
    setAutoSelectedInitiated(true)
    /**
     *  If auto select is ON, we randomly select a free square for the user by
     *  By filterering down an array of all square numbers until only the unselected are left
     *  then randomly selecting one of the remainging squares and fire the selectSquare method.
     * */

    const selectableDrawingSquares = drawing.squares
      .map((square, index) => square === false ? index + 1 : square)
      .filter((square, index) => square === index + 1)
    const randomlySelectedSquare = selectableDrawingSquares[Math.floor(Math.random() * selectableDrawingSquares.length)]
    if (randomlySelectedSquare) {
      setTimeout(() => selectSquare(randomlySelectedSquare), 3000)
    }
  }

  const [isCreatingPromptPiccle, setIsCreatingPromptPiccle] = useState(false)

  useEffect(() => {
    if (drawing && drawing.prompt) {
      if (!isCreatingPromptPiccle) {
        setIsCreatingPromptPiccle(true)

        const piccleRef = firebase.ref(`/piccles/${drawingId}`).push()
        ;(async function() {
          await piccleRef.set({
            userId,
            startTimestamp: new Date().valueOf(),
          })
        })()
        history.push(`/drawings/${drawingId}/promptDraw/${piccleRef.key}`)
      }
    }

    if (
      squareSelectionMode === AUTO_SQUARE_SELECT &&
      drawing &&
      (drawingSquares || drawingSquares === null) &&
      !autoSelectionInitiated
    ) {
      autoSelectSquare()
    }
  })

  const isLoading = !drawing && drawingSquares
  const isDrawingFull = drawingSquares && drawing && Object.keys(drawingSquares).length === drawing.squaresCount
  const headerContent = isDrawingFull ? 'Sorry, this Piccle is full.' : 'Pick a square'

  return (
    <div>
      {isLoading ? (
        'Loading...'
      ) : (
        <div>
          <h2 style={{ lineHeight: '70%' }}>{headerContent}</h2>
          {alertMessage && <h3 style={{ lineHeight: '70%', color: 'red' }}>{alertMessage}</h3>}
          {drawing && drawing.images && (
            <Drawing
              drawingId={drawingId}
              drawingIndex={drawingIndex}
              squaresCount={drawing.squaresCount}
              imageUrl={drawing.images[drawingIndex].imageUrl}
              drawingSquares={drawingSquares}
              onSelectSquare={squareSelectionMode === AUTO_SQUARE_SELECT ? () => {} : selectSquare}
            />
          )}
          {!isDrawingFull && squareSelectionMode === AUTO_SQUARE_SELECT && (
            <h3>You are being assigned a square to draw... please wait</h3>
          )}
          {isDrawingFull && !!isNextDrawing && (
            <h3>Please wait for this Piccle to finish drawing before picking a new square</h3>
          )}
          {isDrawingFull && !isNextDrawing && <h3>This piccle doesn&quot;t have anymore images, game over!</h3>}
        </div>
      )}
    </div>
  )
}

export default compose(
  connect((state, props) => ({ drawing: _.get(state, `firebase.data.drawings.${props.match.params.id}`) })),
  firebaseConnect((props) => {
    // Set listeners based on props (prop is route parameter from react-router in this case)
    return [
      `drawings/${props.match.params.id}`,
      {
        path: '/drawingSquares',
        queryParams: [
          'orderByChild=drawing',
          'notParsed',
          `equalTo=${props.match.params.id}_${props.drawing ? props.drawing.currentImage : 'XXX'}`,
        ],
      },
    ]
  }),
  connect((state, props) => {
    const drawing = _.get(state.firebase.data, `drawings.${props.match.params.id}`)
    return {
      drawingId: props.match.params.id,
      userId: state.firebase.auth.uid,
      drawing,
      drawingSquares: _.get(state.firebase.data, 'drawingSquares'),
      isNextDrawing: drawing
        ? _.get(state.firebase.data, `drawings.${props.match.params.id}.images.${drawing.currentImage + 1}`)
        : false,
      drawingIndex: drawing && drawing.currentImage,
      squareSelectionMode: drawing && drawing.squareSelectionMode,
    }
  }),
)(DrawingContainer)



// WEBPACK FOOTER //
// ./src/containers/drawingContainer.js